import { dynamicEditorComponent } from '@doltech/utils/lib/dynamicWithProps/dynamicEditorComponent';
import * as React from 'react';
import { RenderElementProps } from 'slate-react';

import { SlatePlugin } from '../../../../slatePlugins/slatePlugins.types';
import {
  FAQ_SENTENCES,
  FAQ_SENTENCE,
  FAQ,
  FaqPluginOptions,
  FAQ_QUESTION,
  FAQ_ANSWER,
} from './types';
import { withDynamicBlogEditorPluginHydration } from '@doltech/core/lib/hooks/withDolHydrationOnDemand';
import { FaqReadOnlyPlugin } from './FaqReadOnlyPlugin';

const Faq = withDynamicBlogEditorPluginHydration()(
  dynamicEditorComponent(() => import('./components/Faq').then((mod) => mod.Faq))
);
const FaqSentence = withDynamicBlogEditorPluginHydration({ canInteract: true })(
  dynamicEditorComponent(() => import('./components/FaqSentence').then((mod) => mod.FaqSentence), {
    dependsOn: Faq,
  })
);
const FaqAnswer = withDynamicBlogEditorPluginHydration({ canInteract: true })(
  dynamicEditorComponent(() => import('./components/FaqAnswer').then((mod) => mod.FaqAnswer), {
    dependsOn: Faq,
  })
);
const FaqSentences = withDynamicBlogEditorPluginHydration()(
  dynamicEditorComponent(
    () => import('./components/FaqSentences').then((mod) => mod.FaqSentences),
    {
      dependsOn: Faq,
    }
  )
);
const FaqQuestion = withDynamicBlogEditorPluginHydration({ canInteract: true })(
  dynamicEditorComponent(() => import('./components/FaqQuestion').then((mod) => mod.FaqQuestion), {
    dependsOn: Faq,
  })
);

export const FaqPlugin = (options?: FaqPluginOptions): SlatePlugin => {
  if (options.isReadOnly) {
    return FaqReadOnlyPlugin(options);
  }
  return {
    renderElement: (renderProps: RenderElementProps) => {
      const { element } = renderProps;
      switch (element?.type) {
        case FAQ:
          return <Faq {...renderProps} {...options} />;
        case FAQ_SENTENCES:
          return <FaqSentences {...renderProps} {...options} />;
        case FAQ_SENTENCE:
          return <FaqSentence {...renderProps} {...options} />;
        case FAQ_ANSWER:
          return <FaqAnswer {...renderProps} {...options} />;
        case FAQ_QUESTION:
          return <FaqQuestion {...renderProps} {...options} />;
        default:
      }

      return null;
    },
  };
};
